import { TOOLS_NAVIGATION_ITEMS } from '~/constants/navigation'
import type { TTopbarNavigationItem } from '~/src/types/navigation'

export function useTopbarNavigation() {
  const config = useRuntimeConfig()
  const route = useRoute()

  const topbarNavigation = computed<TTopbarNavigationItem[]>(() => {
    /*
      Note: because some tools are not under /tools path,
      we need to check if the current path is a tool page first.

      We made a proposal to move all tools under /tools path,
      but it was rejected due possible conflicts with the
      public WWW site.
    */

    const toolItems = TOOLS_NAVIGATION_ITEMS.filter(
      (item) => item.href !== '/price-dashboard/chart-builder',
    )
    const isToolPage = toolItems.some((item) =>
      route.path.startsWith(item.href),
    )

    const isAccountPage = route.path.startsWith('/account')

    return [
      {
        name: 'Portal',
        href: '/price-dashboard/chart-builder',
        icon: 'layout/icon-portals',
        current: !isToolPage && !isAccountPage,
      },
      {
        name: 'Tools',
        href: '/tools',
        icon: 'layout/icon-tools',
        current: isToolPage,
      },
      {
        name: 'Source',
        href: config.public.sourceUrl,
        icon: 'layout/icon-source',
        external: true,
      },
      {
        name: 'Events',
        href: `${config.public.marketingUrl}/events`,
        icon: 'layout/icon-events',
        external: true,
      },
    ]
  })

  return { topbarNavigation }
}
